(function () {
  const trigger = document.getElementById('blog-dropdown-trigger')
  const drawer = document.getElementById('blog-dropdown-drawer')

  if (!trigger || !drawer) return

  function toggleDropdown() {
    const isOpen = drawer.classList.toggle('is-open')
    trigger.classList.toggle('is-open', isOpen)
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  }

  trigger.addEventListener('click', toggleDropdown)

  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggleDropdown()
    }
  })

  document.addEventListener('click', function (e) {
    const clickedInside = trigger.contains(e.target) || drawer.contains(e.target)
    if (!clickedInside && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open')
      trigger.classList.remove('is-open')
      trigger.setAttribute('aria-expanded', 'false')
    }
  })
})()
